export default "__VITE_ASSET__BhX1Oa4p__"